module.exports = __webpack_public_path__ + "src/assets/static/img/logo.bdd09d9c.svg";